/* eslint-disable no-undef */
import {
    HTTP,
} from '@/utils/http-common'
import _ from 'lodash'
import {
    redirect,
} from '@/utils/common'
import {
    isCancel,
} from 'axios'

export default {
    // Project endpoints - START
    listProject (parent, project, nextPage = null) {
        if (nextPage) {
            return HTTP.get(nextPage)
        }
        return HTTP.get(`/projects/manage/${project.id}/dataset/`)
    },
    listDetailsProjects (parent, project, nextPage = null) {
        if (nextPage) {
            return HTTP.get(nextPage)
        }
        return HTTP.get(`/projects/manage/${project.id}/dataset_details/`).catch(error => {
            parent.$store.commit('push', {
                msg: 'Error ' + error.response.data.error,
                color: 'error',
            })
        })
    },
    // V2 REFACTORING - END
    list (parent, page) {
        if (page === 0) {
            return HTTP.get('/datastore/dataset/manage/')
        } else if (page !== null) {
            return HTTP.get(page)
        } else {
            return {}
        }
    },
    get (dataset, parent) {
        return HTTP.get('/datastore/dataset/manage/' + dataset.hmd_id + '/')
        /* .then((response) =>{
          console.log(response)
        }).catch(function (error){
          parent.$store.commit('push', {msg: 'error when getting the dataset info', color: 'error'});
          console.log('error '+error.response.status+' - refer to this file and line --->');
        }) */
    },
    get_v1 (dataset, params, headers) {
        const p = '?' + _.join(_.map(params, (o, i) => {
            return i + '=' + (typeof o === 'object' ? JSON.stringify(o) : o)
        }), '&')
        return HTTP.get('/v1/dataset/' + dataset.hmd_id + '/' + (p.replace('?', '') ? p : ''), headers)
        /* .then((response) =>{
          console.log(response)
        }).catch(function (error){
          parent.$store.commit('push', {msg: 'error when getting the dataset info', color: 'error'});
          console.log('error '+error.response.status+' - refer to this file and line --->');
        }) */
    },
    delete (dataset, parent) {
        return new Promise((resolve, reject) => {
            return HTTP.delete('/datastore/dataset/manage/' + dataset.hmd_id + '/')
                .then((response) => {
                    parent.$store.commit('push', {
                        msg: 'Dataset deleted',
                        color: 'success',
                    })
                    return resolve(response)
                }).catch((error) => {
                    let errorMessage = ''

                    for (let i = 0; i < error.response.data.error.length; i++) {
                        if (i > 0) {
                            errorMessage += '\n'
                        }

                        errorMessage += error.response.data.error[i]
                    }

                    parent.$store.commit('push', {
                        msg: errorMessage,
                        color: 'error',
                    })
                    reject(error)
                    // console.log('error '+error.response.status+' - refer to this file and line --->');
                })
        })
    },
    truncate (dataset, parent) {
        return new Promise((resolve, reject) => {
            return HTTP.get('/datastore/dataset/manage/' + dataset.hmd_id + '/truncate')
                .then((response) => {
                    parent.$store.commit('push', {
                        msg: 'Dataset truncated',
                        color: 'success',
                    })
                    return resolve(response)
                }).catch((error) => {
                    let errorMessage = ''

                    for (let i = 0; i < error.response.data.error.length; i++) {
                        if (i > 0) {
                            errorMessage += '\n'
                        }

                        errorMessage += error.response.data.error[i]
                    }

                    parent.$store.commit('push', {
                        msg: errorMessage,
                        color: 'error',
                    })
                    reject(error)
                    // console.log('error '+error.response.status+' - refer to this file and line --->');
                })
        })
    },
    clone (parent, dataset, targetProject, cloneName = null) {
        const params = {
            target_project: targetProject,
        }
        params.name = cloneName || name
        return HTTP.post(`datastore/dataset/manage/${dataset.hmd_id}/clone/`, params).then((result) => {
            parent.$store.commit('push', {
                msg: 'Dataset cloned successfully',
                color: 'success',
            })
            redirect(`projects/${parent.$route.params.project}/view/dataset/${result.data.hmd_id}`)
            return result
        }).catch((error) => {
            parent.$store.commit('push', {
                msg: error,
                color: 'error',
            })
            return error
        })
    },
    update (dataset, parent) {
        return HTTP.put('datastore/dataset/manage/' + parent.dataset.hmd_id + '/', dataset)
            .then((response) => {
                parent.$store.commit('push', {
                    msg: 'Dataset updated',
                    color: 'success',
                })
                return response
            }).catch((error) => {
                if (error.response.data) {
                    let errorMessage = ''

                    for (let i = 0; i < error.response.data.error.length; i++) {
                        if (i > 0) {
                            errorMessage += '\n'
                        }

                        errorMessage += error.response.data.error[i]
                    }

                    parent.$store.commit('push', {
                        msg: errorMessage,
                        color: 'error',
                    })
                    // console.log('error '+error.response.status+' - refer to this file and line --->');
                }
            })
    },
    update_fields (dataset, parent) {
        return new Promise((resolve, reject) => {
            HTTP.put('datastore/dataset/manage/' + dataset.hmd_id + '/fields/', dataset)
                .then((response) => {
                    parent.$store.commit('push', {
                        msg: 'Dataset updated',
                        color: 'success',
                    })
                    resolve(response)
                }).catch((error) => {
                    if (error.response.status !== 500) {
                        let errorMessage = ''
                        for (let i = 0; i < error.response.data.error.length; i++) {
                            if (i > 0) {
                                errorMessage += '\n'
                            }

                            errorMessage += error.response.data.error[i]
                        }
                        parent.$store.commit('push', {
                            msg: errorMessage,
                            color: 'error',
                        })
                    } else {
                        redirect(`projects/${parent.$route.params.project}`, null)
                    }
                    reject(error)
                    // console.log('error '+error.response.status+' - refer to this file and line --->');
                })
        })
    },
    get_api_embed (dataset) {
        return HTTP.get('/gateway/api/datastore/dataset/' + dataset.hmd_id + '/apiembed/')
    },
    delete_column (dataset, column_name) {
        HTTP.post('datastore/dataset/manage/' + dataset.hmd_id + '/column/delete/' + column_name + '/').then((response) => {}).catch((error) => {
            let errorMessage = ''

            for (let i = 0; i < error.response.data.error.length; i++) {
                if (i > 0) {
                    errorMessage += '\n'
                }

                errorMessage += error.response.data.error[i]
            }

            parent.$store.commit('push', {
                msg: errorMessage,
                color: 'error',
            })
            // console.log('error '+error.response.status+' - refer to this file and line --->');
        })
    },
    add_column (dataset, item) {
        const property = item
        property.type = item.type.value
        return HTTP.post('datastore/dataset/manage/' + dataset.hmd_id + '/column/add/', item)
    },
    possible_foreign_datasets (parent = null) {
        return new Promise((resolve, reject) => {
            const url = (parent == null) ? 'datastore/dataset/possible_foreign_keys/' : `datastore/dataset/possible_foreign_keys/${parent.$route.params.project}/`
            HTTP.get(url)
                .then((response) => {
                    return resolve(response)
                }).catch((error) => {
                    let errorMessage = ''

                    for (let i = 0; i < error.response.data.error.length; i++) {
                        if (i > 0) {
                            errorMessage += '\n'
                        }

                        errorMessage += error.response.data.error[i]
                    }

                    parent.$store.commit('push', {
                        msg: errorMessage,
                        color: 'error',
                    })
                    return reject(error)
                })
        })
    },
    reimport (parent, project, dataset, isTruncate, file) {
        return new Promise((resolve, reject) => {
            var form = new FormData()
            form.append('project_id', project)
            form.append('truncate', isTruncate)
            form.append('file', file)
            HTTP.post('datastore/dataset/manage/reimport/' + dataset.hmd_id + '/', form)
                .then((response) => {
                    parent.$store.commit('push', {
                        msg: 'File reimported',
                        color: 'success',
                    })
                    return resolve(response)
                }).catch((error) => {
                    let errorMessage = ''

                    for (let i = 0; i < error.response.data.error.length; i++) {
                        if (i > 0) {
                            errorMessage += '\n'
                        }

                        errorMessage += error.response.data.error[i]
                    }

                    parent.$store.commit('push', {
                        msg: errorMessage,
                        color: 'error',
                    })
                    return reject(error)
                })
        })
    },
    create (dataset, project, parent) {
        return new Promise((resolve, reject) => {
            HTTP.post('datastore/dataset/manage/', dataset)
                .then((response) => {
                    return resolve(response)
                }).catch((error) => {
                    let errorMessage = ''
                    if (error.request.response) {
                        try {
                            const parsed = JSON.parse(error.request.response)
                            errorMessage = parsed.error.join('.\n')
                        } catch {
                            errorMessage = error.request.response
                        }
                    } else {
                        errorMessage = error
                    }
                    parent.$store.commit('push', {
                        msg: errorMessage,
                        color: 'error',
                    })
                    return reject(error)
                })
        })
    },

    schema (parent, project, hmdFileId, options) {
        const body = {
            project_id: project,
            file_id: hmdFileId,
            options: {
                header_index: options.header_index == null ? null : _.toInteger(options.header_index),
                offset: options.offset == null ? null : _.toInteger(options.offset),
                limit: options.limit == null ? null : _.toInteger(options.limit),
                footer_index: options.footer_index == null ? null : _.toInteger(options.footer_index),
                delimiter: options.delimiter,
                encoding: options.encoding,
                sheet: options.sheet == null ? null : _.toInteger(options.sheet),
            },
        }
        if (parent.upload_method == 'connector') { body.config = parent.connections_method.selectedIntegration }
        return new Promise((resolve, reject) => {
            HTTP.post('datastore/dataset/manage/schema_from_file/', body).then(r => {
                resolve(r)
            }).catch(err => {
                reject(err)
                parent.$store.commit('push', {
                    msg: 'Error : ' + err.response.data.error,
                    color: 'error',
                })
            })
        })
    },
    preview (parent, project, hmdFileId, options, headers = {}) {
        const body = {
            project_id: project,
            file_id: hmdFileId,
            options: {
                header_index: options.header_index == null ? null : _.toInteger(options.header_index),
                offset: options.offset == null ? null : _.toInteger(options.offset),
                limit: options.limit == null ? null : _.toInteger(options.limit),
                footer_index: options.footer_index == null ? null : _.toInteger(options.footer_index),
                delimiter: options.delimiter,
                encoding: options.encoding,
                sheet: options.sheet == null ? null : _.toInteger(options.sheet),
            },
        }
        return new Promise((resolve, reject) => {
            HTTP.post('datastore/dataset/manage/preview/', body, headers).then(r => {
                resolve(r)
            }).catch(err => {
                console.log(err)
                if (!isCancel(err) && err.response) {
                    parent.$store.commit('push', {
                        msg: 'Error : ' + err.response.data.error,
                        color: 'error',
                    })
                }
                reject(err)
            })
        })
    },
    uploadFromStorage (parent, project, config) {
        return new Promise((resolve, reject) => {
            HTTP.post('datastore/dataset/manage/upload_from_storage/', config).then(r => {
                resolve(r)
            }).catch(err => {
                reject(err)
                parent.$store.commit('push', {
                    msg: 'Error : ' + err.response.data.error,
                    color: 'error',
                })
            })
        })
    },
    upload (parent, project, file) {
        const formData = new FormData()
        return new Promise((resolve, reject) => {
            formData.append('project_id', project)
            formData.append('file', file)

            HTTP.post('datastore/dataset/manage/upload/', formData).then(r => {
                resolve(r)
            }).catch(err => {
                reject(err)
                parent.$store.commit('push', {
                    msg: 'Error : ' + err.response.data.error,
                    color: 'error',
                })
            })
        })
    },
    run_query (dataset, parent) {
        HTTP.post('datastore/dataset/analytics/' + dataset.hmd_id + '/', {
            query: '',
            limit: false,
        }).then(response => {
            /* parent.sqlResult = true
             parent.sql.error = ""
             parent.sql.src = response.data.query */
            var item
            var items = response.data.fields
            parent.headerCell = []
            for (item in items) {
                parent.headerCell.push({
                    value: items[item].name,
                    shown: true,
                    sortable: false,
                    type: items[item].type,
                    query: {
                        operator: items[item].primary_key ? 'equals' : '',
                        values: [],
                    },
                    isFiltering: false,
                    pk: items[item].primary_key,
                })
            }
            parent.tableData = response.data.data
            parent.totalItems = response.data.count
        }).catch(error => {
            parent.$store.commit('push', {
                msg: 'Error ' + error.response.data.error,
                color: 'error',
            })
            console.log('error ' + error.response.status + ' - refer to this file and line --->')
        })
    },
    addPermission (parent, dataset, user, permission) {
        if (typeof (dataset.permissions.find(x => x.username === user)) !== 'undefined') {
            parent.$store.commit('push', {
                msg: 'User already in the team',
                color: 'error',
            })
        } else {
            HTTP.post('permissions/dataset/' + dataset.hmd_id + '/', {
                username: user,
                perms: permission,
            }).then((response) => {
                parent.$store.commit('push', {
                    msg: 'Invite sent',
                    color: 'success',
                })
                parent.$emit('modifyPermissions', {
                    type: 'addPermission',
                    user: user,
                    permission: permission,
                })
            }).catch((error) => {
                if (error.response.status === 404) {
                    parent.$store.commit('push', {
                        msg: 'Username does not exist',
                        color: 'error',
                    })
                    console.log('error ' + error.response.status + ' - refer to this file and line --->')
                } else {
                    console.log('error ' + error.response.status + ' - refer to this file and line --->')
                }
            })
        }
    },
    changePermission (parent, dataset, user, permission) {
        HTTP.post('permissions/dataset/' + dataset.hmd_id + '/', {
            username: user,
            perms: permission,
        }).then((response) => {
            parent.$store.commit('push', {
                msg: 'Permissions updated',
                color: 'success',
            })
            parent.$emit('modifyPermissions', {
                type: 'changePermission',
                user: user,
                permission: permission,
            })
        }).catch((error) => {
            if (error.response.status === 404) {
                let errorMessage = ''

                for (let i = 0; i < error.response.data.error.length; i++) {
                    if (i > 0) {
                        errorMessage += '\n'
                    }

                    errorMessage += error.response.data.error[i]
                }

                parent.$store.commit('push', {
                    msg: errorMessage,
                    color: 'error',
                })
                // console.log('error '+error.response.status+' - refer to this file and line --->');
            } else {
                // console.log('error '+error.response.status+' - refer to this file and line --->');
            }
        })
    },
    deletePermission (parent, dataset, user) {
        HTTP.delete('permissions/dataset/' + dataset.hmd_id + '/username/' + user.username + '/')
            .then((response) => {
                parent.$store.commit('push', {
                    msg: 'Permission deleted',
                    color: 'success',
                })
                parent.$emit('modifyPermissions', {
                    type: 'deletePermission',
                    user: user,
                })
            }).catch((error) => {
                let errorMessage = ''

                for (let i = 0; i < error.response.data.error.length; i++) {
                    if (i > 0) {
                        errorMessage += '\n'
                    }

                    errorMessage += error.response.data.error[i]
                }

                parent.$store.commit('push', {
                    msg: errorMessage,
                    color: 'error',
                })
                // console.log('error '+error.response.status+' - refer to this file and line --->');
            })
    },
    getMetrics (parent, dataset, refresh = false) {
        var metrics_url = 'metrics/dataset/' + dataset.hmd_id + '/weekly/'
        if (refresh) {
            metrics_url = 'metrics/dataset/' + dataset.hmd_id + '/weekly_refresh/'
        }
        return HTTP.get(metrics_url)
    },
    sendQuery (page, dataset, query) {
        return HTTP.get('v1/dataset/' + dataset.hmd_id + '/?page=' + page, {
            params: {
                filter: JSON.stringify(query),
            },
        })
    },
    searchUsers (search, parent) {
        return HTTP.get('/permissions/users/search/?username=' + search)
    },
    insertRow (parent, dataset, row) {
        /* console.log(datasetName + ": inserting row ") */
        return HTTP.post('/v1/dataset/' + dataset.hmd_id + '/', row)
            .then((response) => {
                parent.$store.commit('push', {
                    msg: 'Information added',
                    color: 'success',
                })
                parent.newRow = {}
                parent.$emit('loading', true)
            }).catch((error) => {
                let message = ''
                for (const err in error.response.data) {
                    message += '- ' + err + ' : ' + error.response.data[err] + '\n'
                }
                parent.$store.commit('push', {
                    msg: message,
                    color: 'error',
                })
            })
    },
    updateRow (parent, dataset, rowToEdit, datasetFields) {
        let keys = {}
        keys = _.join(_.map(_.filter(datasetFields, ({
            primary_key: true,
        })), (c, i) => {
            return `${c.name}=${rowToEdit[c.name]}`
        }), ',')
        return HTTP.post('/v1/dataset/' + dataset.hmd_id + '/by_id/' + keys + '/', rowToEdit)
            .then((response) => {
                parent.$store.commit('push', {
                    msg: 'Information Updated',
                    color: 'success',
                })
                parent.$emit('loading', true)
            }).catch((error) => {
                let message = ''
                for (const err in error.response.data) {
                    message += '- ' + err + ' : ' + error.response.data[err] + '\n'
                }
                parent.$store.commit('push', {
                    msg: message,
                    color: 'error',
                })
            })
    },
    deleteRow (parent, dataset, rowToDelete, datasetFields) {
        let keys = {}
        keys = _.join(_.map(_.filter(datasetFields, ({
            primary_key: true,
        })), (c, i) => {
            return `${c.name}=${rowToDelete[c.name]}`
        }), ',')
        return HTTP.delete('/v1/dataset/' + dataset.hmd_id + '/by_id/' + keys + '/')
            .then((response) => {
                parent.$store.commit('push', {
                    msg: 'Information removed',
                    color: 'success',
                })
                parent.$emit('loading', true)
            }).catch((error) => {
                let message = ''
                for (const err in error.response.data) {
                    message += '- ' + err + ' : ' + error.response.data[err] + '\n'
                }
                parent.$store.commit('push', {
                    msg: message,
                    color: 'error',
                })
            })
    },
    updateShowColumnsPreference (parent, dataset, datasetUpdatedField) {
        return HTTP.post(`datastore/dataset/manage/${dataset.hmd_id}/preferences/${datasetUpdatedField.shown ? 'show' : 'hide'}/${datasetUpdatedField.id}/`, {})
            .then((response) => {}).catch((error) => {
                parent.$store.commit('push', {
                    msg: error,
                    color: 'error',
                })
            })
    },
    exportDataToCSV (parent, dataset) {
        return HTTP.get('/v1/dataset/' + dataset.hmd_id + '/export/')
            .then((r) => {
                const uri = encodeURI('data:text/csv;charset=utf-8,' + r.data)
                const link = document.createElement('a')
                link.setAttribute('href', uri)
                link.setAttribute('download', dataset.hmd_id.replace('-', '') + '_' + new Date().toISOString().slice(0, 19) + '.csv')
                link.click()
            }).catch((error) => {
                let message = ''
                for (const err in error.response.data) {
                    message += err + ' : ' + error.response.data[err] + '\n'
                }
                parent.$store.commit('push', {
                    msg: message,
                    color: 'error',
                })
            })
    },
    getFieldsOptions () {
        return new Promise((resolve, reject) => {
            return HTTP.get('/datastore/dataset/available_options/').then((result) => {
                return resolve(result)
            }).catch((error) => {
                parent.$store.commit('push', {
                    msg: error,
                    color: 'error',
                })
                reject(error)
            })
        })
    },
}
